import React from 'react';
import AutomaticVideoPlayer from 'core/modules/AutomaticVideoPlayer/AutomaticVideoPlayer';

function HolidayBorderItem({
  isVideo, src, className, imageAlternateText,
}) {
  return (
    <div className={className}>
      {isVideo ? (
        <AutomaticVideoPlayer className="mn_holidayBorder mn_video" src={src} title={imageAlternateText} />
      ) : (
        <div
          className="mn_holidayBorder"
          style={{ background: `url(${src})` }}
        />
      )}
    </div>
  );
}

export default HolidayBorderItem;
